import React from "react";
import Dashboard from "../Dashboard/Dashboard";
import PlanFeatureManagementListing from "../../Sections/PlanFeatureManagement"

const PlanFeatureManagementComponent = () => {
  return <Dashboard sectionName={<PlanFeatureManagementListing />} />;
};

export default PlanFeatureManagementComponent;
